<template>
  <div class="add-basic-campaign-price">
    <ElForm
      ref="campaignModel"
      :model="campaignModel"
      :rules="campaignRules"
      label-position="right"
      @submit.native.prevent="submitForm"
    >
      <FormItemWithHint
        prop="targetedCpi"
        :label="$t('ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.TARGET_CPI')"
        :hint="$t('HINTS.BASIC.TARGET_CPI')"
      >
        <ElInput
          v-model="campaignModel.targetedCpi"
          name="targetedCpi"
          required
        />
      </FormItemWithHint>

      <FormItemWithHint
        prop="budget"
        :label="$t('ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.BUDGET')"
        :hint="$t('HINTS.DISCOVERY.BUDGET')"
      >
        <ElInput v-model="campaignModel.budget" name="budget" required />
      </FormItemWithHint>

      <BudgetError
        v-if="creditIsLessThanBudget"
        class="add-discovery-campaign-city-and-price-setting__budget-error"
      />

      <ElFormItem
        prop="isDiscoveryAdsEnabled"
        class="add-basic-campaign-price__is-discovery-enabled"
      >
        <ElCheckbox v-model="campaignModel.isDiscoveryAdsEnabled">
          {{ $t('ADVERTISEMENT.NEW_CAMPAIGN_BASIC.ENABLE_DISCOVERY_ADS') }}
          <Hint :message="$t('HINTS.BASIC.ENABLE_DISCOVERY_ADS')" />
        </ElCheckbox>
      </ElFormItem>

      <div class="row align-middle">
        <div class="columns">
          <ElButton
            type="text"
            class="add-basic-campaign-price__back"
            @click.native="$emit('back')"
          >
            <i class="el-icon-right" />
            {{ $t('ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY.PREVIOUS_STEP') }}
          </ElButton>
        </div>
        <div class="columns shrink">
          <ElButton
            type="primary"
            native-type="submit"
            size="large"
            :loading="isLoading"
            :disabled="creditIsLessThanBudget"
            @click.native.prevent="submitForm"
          >
            {{ $t('ADVERTISEMENT.NEW_CAMPAIGN_BASIC.ADD_CAMPAIGN') }}
          </ElButton>
        </div>
      </div>
    </ElForm>
  </div>
</template>

<script>
import requiredWithMessage from '@/utils/validation-rules/required';
import FormItemWithHint from '@@/common/FormItemWithHint';
import BudgetError from '../../../../common/BudgetError';
import Hint from '@@/common/Hint';
import form from '@/mixins/form';

export default {
  name: 'AddBasicCampaignPrice',

  components: {
    FormItemWithHint,
    BudgetError,
    Hint,
  },

  mixins: [form],

  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    resetController: {
      type: Object,
      required: true,
    },
    credit: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      campaignModel: {
        budget: '',
        isDiscoveryAdsEnabled: true,
      },
    };
  },

  computed: {
    campaignRules() {
      return {
        budget: {
          ...requiredWithMessage(this.$t('VALIDATION_REQUIRED_ERR')),
          type: 'string',
        },
        targetedCpi: {
          ...requiredWithMessage(this.$t('VALIDATION_REQUIRED_ERR')),
          type: 'string',
        },
      };
    },
    creditIsLessThanBudget() {
      return this.credit < this.campaignModel.budget;
    },
  },

  created() {
    this.resetController.onReset(this.reset);
  },

  beforeDestroy() {
    this.resetController.removeOnReset(this.reset);
  },

  methods: {
    submitForm() {
      if (!this.isValid('campaignModel') || this.creditIsLessThanPrice) {
        return false;
      }
      this.$emit('submit', this.campaignModel);
    },
    reset() {
      this.resetForm('campaignModel');
    },
  },
};
</script>

<style lang="scss">
.add-basic-campaign-price {
  &__back {
    font-size: 1rem;
    color: $lb-color-secondary;

    &:hover {
      color: lighten($lb-color-secondary, 5%);
    }
  }

  &__is-discovery-enabled {
    .el-checkbox {
      display: flex;
      align-items: baseline;
    }

    .el-checkbox__label {
      white-space: normal;
    }
  }
}
</style>
